<template>
    <div id="print" class="course_main" :style="backgroundDiv">
        <div class="back_nav" @click="goBack"><img src="../../assets/back_nav.png"/></div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" style="top: 20px;right: 30px;" v-if="totalStarCount > 0">
            <img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span>
        </div>
        <audio v-show="false" @ended="playEnded()" @error="playEnded" id="musicMp3" controls=""></audio>
        <audio v-show="false" :src="starAudioUrl" id="star_audio"/>
        <audio v-show="false" :src="greatAudioUrl" id="great_audio"/>

        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="transition" v-if="showTransition">
            <div class="back_nav2" v-on:click.stop="gameQuitClick"><img src="../../assets/back_nav.png"/></div>
            <div class="content">
                <div class="content2">
                    <div class="div_icon">
                        <img id="success_icon" style="display: none" class="icon" src="@/Images/jiangbei.png"/>
                    </div>
                    <div class="content3">
                        <div class="transition_comeback" v-on:click.stop="gameQuitClick">
                            <img src="../../Images/transition_comeback.png"/>
                        </div>
                        <div class="transition_next" v-on:click.stop="nextPageClick">
                            <span>亲子拓展</span>
                            <img src="../../assets/chevron-thin-right.png"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress">
            <div class="current_progress" :style="{width: getCurrentProgressWidth() + 'px'}"></div>
            <div class="total_progress"></div>
            <div class="progress_image" :style="{marginLeft:(getCurrentProgressWidth() + 15) + 'px'}"><img src="@/Images/icon_progress.png" alt=""/></div>
        </div>

        <!-- 左边录音 -->
        <div class="left_record">
            <div class="record">
                <div v-if="!childCanPlay" class="audio_record_anim recording" :style="{display: isRecording1 ? '' : 'none'}"
                     @click="endRecording"></div>
                <img v-if="!childCanPlay" class="play_animate" :style="{display: isRecording1 ? 'none' : ''}" src="@/assets/icon_record_audio.png" alt="" @click="startRecording(1)"/>
            </div>
            <img v-if="childCanPlay" class="record" src="@/assets/icon_not_record_audio.png" alt="" />
            <img class="user_head" src="@/Images/icon_question.png" alt="" />
            <img v-if="!childCanPlay" class="dialogue_back" src="@/Images/dialogue_back.png" alt="" />
            <div v-if="!childCanPlay" class="dialogue_text" @click="playQaAudio(1)">
                {{geneQaQustion(1)}}
            </div>
        </div>

        <!-- 右边录音 -->
        <div class="right_record">
            <div class="record">
                <div v-if="childCanPlay" class="audio_record_anim recording" :style="{display: isRecording2 ? '' : 'none'}"
                     @click="endRecording"></div>
                <img v-if="childCanPlay" class="play_animate" :style="{display: isRecording2 ? 'none' : ''}" src="@/assets/icon_record_audio.png" alt="" @click="startRecording(2)"/>
            </div>
            <img v-if="!childCanPlay" class="record" src="@/assets/icon_not_record_audio.png" alt="" />
            <img class="user_head" src="@/Images/icon_answer.png" alt="" />
            <img v-if="childCanPlay" class="dialogue_back" src="@/Images/dialogue_back.png" alt="" />
            <div v-if="childCanPlay" class="dialogue_text" @click="playQaAudio(2)">
                {{geneQaQustion(2)}}
            </div>
        </div>

        <!-- 录音结果 -->
        <div id="record_result" class="dialogue_data">
            <div v-for="(itemQa,index) in listRecord" :key="index">
                <div class="question" v-if="itemQa.isQuestion === 1">
                    <img src="@/Images/icon_question.png" alt="" />
                    <div class="sanjiao_right"></div>
                    <div class="content" @click="playAudio(index, itemQa.questionAudio)"><div class="word_content">{{itemQa.question}}</div>
                        <div :id="genePlayQaId(index)" class="dialogue_playing img_play" style="display: none"></div>
                        <img :id="geneQaId(index)" class="img_play" src="@/Images/audio_icon_play3.png" />
                    </div>
                </div>
                <div class="answer" v-else>
                    <div class="content" @click="playAudio(index, itemQa.answerAudio)"><div class="word_content">{{itemQa.answer}}</div>
                        <div :id="genePlayQaId(index)" class="dialogue_playing img_play" style="display: none"></div>
                        <img :id="geneQaId(index)" class="img_play" src="@/Images/audio_icon_play3.png" />
                    </div>
                    <div class="sanjiao_left"></div>
                    <img src="@/Images/icon_answer.png" alt="" />
                </div>
            </div>
            <div class="bottom_space"></div>
        </div>

        <div class="scene_des" v-if="!isEmpty(listQa)">{{listQa[playIndex].description}}</div>
    </div>
</template>

<script>
    import $ from "jquery";
    import Vue from "vue";
    import {Indicator, Toast} from "mint-ui";
    import Utils from '@/pages/Program/util2.js';

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {
        data() {
            return {
                lessonId: 0,
                listDialogue: [],
                listQa: [],
                listRecord: [],
                audioUrl: '',
                preId: '',
                prePlayId: '',
                currentId: '',
                currentPlayId: '',
                totalCount: 0,
                hadRecordCount: 0,
                childCanPlay: false,
                playIndex: 0,
                isPlayingQa: 0,
                hasEvaluation: 0,
                isRecording1: false,
                isRecording2: false,
                recordingType: 0,
                showTransition: false,
                starCount: 0,
                starAudioUrl: "",
                showStarTransition: false,
                showExitConfirm: 0,
                totalStarCount: 0,
                fromPage: 0,
                greatAudioUrl:"https://img.xiaohuasheng.cn/great.mp3",
                pingceTimeOut:null,
                backgroundDiv:{
                    backgroundImage:'url(' + require('../../assets/qinzi_bg.jpg') + ')',
                    backgroundRepeat:'no-repeat',
                    backgroundSize:'auto 100%',
                    "background-position": "center 0"}
            }
        },
        methods: {
            goBack() {
                this.showExitConfirm = 1;
            },
            gameQuitClick() {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.showExitConfirm = 0;
                this.$router.go(this.fromPage === 1 ? -2 : -1);
            },
            nextPageClick() {
                setTimeout(() => {
                    this.cancelEvaluating();
                }, 100);

                this.$router.replace({name: "PExpansion", query: {lessonId: this.lessonId, fromPage: this.fromPage}})
            },
            // 录音相关
            sentenceStartRecordAnimation() {
                let that = this;

                if (that.recordingType === 1) {
                    that.isRecording1 = true;
                } else if (that.recordingType === 2) {
                    that.isRecording2 = true;
                }
            },
            startRecording(type) {
                let that = this;
                that.recordingType = type;

                if ((that.recordingType === 1 && that.isRecording1) ||
                    (that.recordingType === 2 && that.isRecording2)) {
                    return;
                }

                that.playEnded();
                let vPlatform = that.judgePlatform();
                let objQa = that.listQa[that.playIndex];

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("开启录音: IOS平台");
                    // let vUrl = "readingclubapp:evaluatingWithType:" + 2 + ":" + (that.recordingType === 1 ? objQa.question : objQa.answer);
                    // document.location = vUrl;
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    sentenceStartRecordAnimation();
                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 5000);
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    // window.console.log("开启录音: android平台");
                    // window.note.evaluatingWithType(2, that.recordingType === 1 ? objQa.question : objQa.answer);
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    sentenceStartRecordAnimation();
                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 5000);
                } else {
                    Toast("此浏览器不支持录音");
                }
            },
            sentenceEndRecordAnimation() {
                let that = this;

                if (that.recordingType === 1) {
                    that.isRecording1 = false;
                } else if (that.recordingType === 2) {
                    that.isRecording2 = false;
                }

                // Indicator.open('上传中...');
                // $(".mint-indicator-wrapper").css({'position':'fixed', 'transform':'rotate(90deg)', 'top':'calc((100% - 101px)/2)', 'left':'calc((100% - 108px)/2)'});
            },
            sentenceCloseIndicator() {
                Indicator.close();
            },
            sentencePlayRecordAudio(audio, finish, wordCardId, sentenceId) {
                let that = this;

                // 录完音处理，开始下一个录音
                if (!that.isEmpty(that.listQa)) {
                    that.hadRecordCount += 1;

                    // 不存储录音
                    let objQa = that.listQa[that.playIndex];
                    Vue.set(that.listRecord, that.playIndex, objQa);

                    if (that.playIndex < that.listQa.length - 1) {
                        that.playIndex += 1;
                        let vQa = that.listQa[that.playIndex];
                        that.childCanPlay = vQa.isQuestion === 0;
                    } else {
                        // 最后一题
                        that.showTransition = true;

                        setTimeout(function () {
                            const greatAudio = document.getElementById('great_audio');
                            greatAudio.play();
                            $("#success_icon").show(800, function(){});
                        }, 20);
                    }

                    setTimeout(() => {
                        var container = document.getElementById("record_result");
                        container.scrollTop = container.scrollHeight;
                    }, 200);
                }
            },
            evaluatingResult(result) {
                let that = this;
                that.evaluatingResultForTimeout(result, 0);
            },
            evaluatingResultForTimeout(result, isTimeout) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3 && isTimeout !== 1) {
                    // 3-app平台IOS平台
                    return;
                }

                that.starCount = that.getRandomInt(2, 3);
                that.showStarTransition = true;

                // 如果分数不足1.5，重新播放
                if (that.starCount < 1 && that.hasEvaluation === 0) {
                    that.showStarTransition = false;
                    that.hasEvaluation += 1;
                    that.starAudioUrl = that.getProgramAudioUrl(that.starCount);

                    setTimeout(() => {
                        const starAudio = document.getElementById('star_audio');
                        starAudio.play();
                    }, 200);

                    let objQa = that.listQa[that.playIndex];

                    setTimeout(() => {
                        that.playQaAudio(objQa.isQuestion === 1 ? 1 : 2);
                    }, 3000);
                    return;
                }

                // 发放星星，延时2s关闭
                setTimeout(() => {
                    that.isRecording1 = false;
                    that.isRecording2 = false;

                    if (that.starCount > 0) {
                        that.starAudioUrl = that.getProgramAudioUrl(that.starCount);
                        that.addStar(that.starCount);

                        setTimeout(() => {
                            const starAudio = document.getElementById('star_audio');
                            starAudio.play();
                        }, 200);
                    }

                    for (let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i * 250, function () {
                            if (i === 3) {
                                setTimeout(() => {
                                    that.showStarTransition = false;
                                    let starAnimation = $(".star_animation");
                                    starAnimation.show();
                                    starAnimation.animate({top:"20px", right:"30px"}, 500, function() {
                                        starAnimation.hide();
                                        starAnimation.css({top:"", right:""});
                                    });
                                }, 800);
                            }
                        });
                    }

                    setTimeout(() => {
                        that.showStarTransition = false;
                        that.hasEvaluation = 0;

                        // 录完音处理，开始下一个录音
                        if (!that.isEmpty(that.listQa)) {
                            that.hadRecordCount += 1;

                            // 不需要存储录音
                            let objQa = that.listQa[that.playIndex];
                            Vue.set(that.listRecord, that.playIndex, objQa);

                            if (that.playIndex < that.listQa.length - 1) {
                                that.playIndex += 1;
                                let vQa = that.listQa[that.playIndex];
                                that.childCanPlay = vQa.isQuestion === 0;

                                setTimeout(() => {
                                    that.playQaAudio(vQa.isQuestion === 1 ? 1 : 2);
                                }, 100);
                            } else {
                                // 最后一题
                                that.showTransition = true;
                                Utils.$emit('setStarCount','2');

                                setTimeout(function () {
                                    const greatAudio = document.getElementById('great_audio');
                                    greatAudio.play();
                                    $("#success_icon").show(800, function(){});
                                }, 100);
                            }

                            setTimeout(() => {
                                var container = document.getElementById("record_result");
                                container.scrollTop = container.scrollHeight;
                            }, 200);
                        }
                    }, 2500);
                }, 100);
            },
            cancelEvaluating() {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    // document.location = "readingclubapp:cancelEvaluating";
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.note.cancelEvaluating();
                }
            },
            evaluatingError: function (errorCode) {
                let that = this;
                window.console.log("错误码：" + errorCode);

                if (that.evaluatingCount > 0) {
                    // 播放当前音频
                    setTimeout(() => {
                        that.showStarTransition = false;
                        that.hasEvaluation = 0;
                        that.isRecording1 = false;
                        that.isRecording2 = false;

                        // 录完音处理，开始下一个录音
                        if (!that.isEmpty(that.listQa)) {
                            that.hadRecordCount += 1;

                            // 不需要存储录音
                            let objQa = that.listQa[that.playIndex];
                            Vue.set(that.listRecord, that.playIndex, objQa);

                            if (that.playIndex < that.listQa.length - 1) {
                                that.playIndex += 1;
                                let vQa = that.listQa[that.playIndex];
                                that.childCanPlay = vQa.isQuestion === 0;

                                setTimeout(() => {
                                    that.playQaAudio(vQa.isQuestion === 1 ? 1 : 2);
                                }, 100);
                            } else {
                                // 最后一题
                                that.showTransition = true;
                                Utils.$emit('setStarCount','2');

                                setTimeout(function () {
                                    const greatAudio = document.getElementById('great_audio');
                                    greatAudio.play();
                                    $("#success_icon").show(800, function(){});
                                }, 100);
                            }

                            setTimeout(() => {
                                var container = document.getElementById("record_result");
                                container.scrollTop = container.scrollHeight;
                            }, 200);
                        }
                    }, 2500);
                    return;
                }

                if (errorCode === 10118) {
                    // 重新开始录入
                    that.closeStarTransition();
                    that.evaluatingCount += 1;

                    that.starAudio = that.getProgramAudioUrl(0);
                    setTimeout(() => {
                        const starAudio = document.getElementById('star_audio');
                        starAudio.play();
                    }, 200);

                    let objQa = that.listQa[that.playIndex];

                    setTimeout(() => {
                        that.playQaAudio(objQa.isQuestion === 1 ? 1 : 2);
                    }, 3000);
                } else {
                    Toast("错误码：" + errorCode);
                }
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            addStar: function(starCount) {
                let that = this;
                let url = "englishProgram/addStar/" + that.lessonId + "/" + starCount;

                this.$axios.get(url).then((response) => {
                    that.totalStarCount = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            endRecording() {
                let that = this;

                if (that.recordingType === 1) {
                    that.isRecording1 = false;
                } else if (that.recordingType === 2) {
                    that.isRecording2 = false;
                }

                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    // 3-app平台IOS平台
                    window.console.log("关闭录音: IOS平台 ");
                    // let vUrl = "readingclubapp:endEvaluating";
                    // document.location = vUrl;
                    if (that.pingceTimeOut != null) {
                        clearTimeout(that.pingceTimeOut);
                        that.pingceTimeOut = null;
                    }

                    that.pingceTimeOut = setTimeout(function () {
                        that.evaluatingResultForTimeout(1, 1);
                    }, 800);
                } else if (vPlatform === 4) {
                    // 4-app平台android平台
                    window.console.log("关闭录音: android平台");

                    window.note.endEvaluating();
                } else {
                    window.console.log("关闭录音: 其它平台");
                    Toast("此浏览器不支持录音");
                }
            },
            // 录音相关结束
            getCurrentProgressWidth: function () {
                let that = this;

                if (that.totalCount === 0) {
                    return 0;
                }

                var height = document.documentElement.clientHeight;
                return (height/2.0 - 55) * that.hadRecordCount / that.totalCount;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
            showStatusWhite:function (status) {
                let that = this;

                if (that.isAppIos()) {
                    document.location = "readingclubapp:changeStatusStyle:" + status;
                }

                if (that.isAppAndroid()) {
                    window.note.changeStatusStyle(status);
                }
            },
            geneQaQustion: function (type) {
                let that = this;
                let objQa = that.listQa[that.playIndex];

                if (this.isEmpty(objQa)) {
                    return "";
                }

                return type === 1 ? objQa.question : objQa.answer;
            },
            geneQaId: function(index) {
                return "qa_" + index;
            },
            genePlayQaId: function(index) {
                return "qa_play_" + index;
            },
            hideStatusAndStopAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:hideStatusAndStopAudio";
                }

                if (vPlatform === 4) {
                    window.note.hideStatusAndStopAudio();
                }
            },
            stopOtherAudio: function () {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:stopOtherAudio";
                }

                if (vPlatform === 4) {
                    window.note.stopOtherAudio();
                }
            },
            playQaAudio: function (type) {
                let that = this;
                let objQa = that.listQa[that.playIndex];
                let vAudioUrl = type === 1 ? objQa.questionAudio : objQa.answerAudio;

                if (that.isEmpty(vAudioUrl)) {
                    return;
                }

                // 取消评测
                if (that.isRecording1 || that.isRecording2) {
                    that.cancelEvaluating();
                    that.isRecording1 = false;
                    that.isRecording2 = false;
                }

                const musicMp3 = document.getElementById('musicMp3');
                musicMp3.src = that.$qiNiuDomainBase + vAudioUrl;
                let playPromise = musicMp3.play();
                that.isPlayingQa = type;

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + vError);
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            playAudio: function (index, qaAudioUrl) {
                let that = this;
                if (that.isEmpty(qaAudioUrl)) {
                    return;
                }

                that.preId = that.currentId;
                that.prePlayId = that.currentPlayId;

                let vQaId = that.geneQaId(index);
                let vPlayId = that.genePlayQaId(index);
                that.currentId = vQaId;
                that.currentPlayId = vPlayId;

                if (!that.isEmpty(that.preId)) {
                    // 显示
                    $("#" + that.preId).show();
                }

                if (!that.isEmpty(that.prePlayId)) {
                    // 隐藏
                    $("#" + that.prePlayId).hide();
                }

                if (!that.isEmpty(that.currentId)) {
                    // 隐藏
                    $("#" + that.currentId).hide();
                }

                if (!that.isEmpty(that.currentPlayId)) {
                    // 显示
                    $("#" + that.currentPlayId).show();
                }

                // that.audioUrl = that.$qiNiuDomainBase + qaAudioUrl;
                const musicMp3 = document.getElementById('musicMp3');
                musicMp3.src = that.$qiNiuDomainBase + qaAudioUrl;
                let playPromise = musicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + vError);
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            playEnded: function () {
                let that = this;
                if (!that.isEmpty(that.currentId)) {
                    // 隐藏
                    $("#" + that.currentId).show();
                }

                if (!that.isEmpty(that.currentPlayId)) {
                    // 显示
                    $("#" + that.currentPlayId).hide();
                }

                var musicMp3 = document.getElementById('musicMp3');
                musicMp3.pause();

                // 如果播放原始音频开始启动录音
                if (that.isPlayingQa > 0) {
                    let vType = that.isPlayingQa;
                    that.isPlayingQa = 0;

                    setTimeout(() => {
                        that.startRecording(vType);
                    }, 300);
                }
            },
        },
        created() {
            let that = this;
            // 客户端调用方法组
            window.sentenceStartRecordAnimation = that.sentenceStartRecordAnimation;
            window.sentenceEndRecordAnimation = that.sentenceEndRecordAnimation;
            window.sentenceCloseIndicator = that.sentenceCloseIndicator;
            window.sentencePlayRecordAudio = that.sentencePlayRecordAudio;
            window.evaluatingResult = that.evaluatingResult;
            window.evaluatingError = that.evaluatingError;
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(this.$route.query.lessonId);
            let vFromPage = parseInt(that.$route.query.fromPage);
            let url = "englishProgram/getDialog/" + vLessonId;

            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.fromPage = vFromPage;
                that.listDialogue = response.data;

                let vCount = 0;
                that.listDialogue.forEach((dialogue) => {
                    if (that.totalStarCount === 0) {
                        that.totalStarCount = dialogue.totalStarCount;
                    }

                    dialogue.qaList.forEach((item) => {
                        item.description = dialogue.description;
                        Vue.set(that.listQa, vCount, item);
                        vCount += 1;
                    });
                });

                that.totalCount = vCount;
                that.hideStatusAndStopAudio();
                let vQa;

                if (!that.isEmpty(that.listQa)) {
                    vQa = that.listQa[0];
                }

                setTimeout(() => {
                    transformView();

                    setTimeout(() => {
                        if (!that.isEmpty(vQa)) {
                            that.playQaAudio(vQa.isQuestion === 1 ? 1 : 2);
                        }
                    }, 100);
                }, 200);
            }).catch(function (error) {
                window.console.log(error)
            });
        },
        beforeRouteEnter(to, form, next) {
            next(vm=>{
                vm.showStatusWhite(0);
            });
        },
        beforeRouteLeave(to, form, next) {
            this.showStatusWhite(1);
            next();
        },
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .course_main {
        width: 100%;
        height: 100%;
    }

    .progress {
        width: 50vmax;
        height: 40px;
        position: absolute;
        left: 50%;
        top: 5px;
        -webkit-transform: translateX(-50%);
        background-color: white;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -moz-border-radius: 20px;
    }
    .progress_image {
        position: absolute;
        z-index: 12;
        margin-left: 15px;
    }
    .progress_image img {
        width: 30px;
        height: 30px;
        margin-top: 5px;
    }
    .progress .total_progress {
        height: 10px;
        width: calc(50vmax - 50px);
        position: absolute;
        left: 25px;
        top: 15px;
        background-color: #fbefcb;
        z-index: 10;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .progress .current_progress {
        height: 10px;
        position: absolute;
        left: 25px;
        top: 15px;
        background-color: #ed7066;
        z-index: 11;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    /* 左边布局 */
    .left_record {
        position: absolute;
        width: 25vmax;
        height: 100vmin;
        left: 0;
    }

    /* 右边布局 */
    .right_record {
        position: absolute;
        width: 25vmax;
        height: 100vmin;
        right: 0;
    }

    .record {
        position: absolute;
        width: 60px;
        height: 60px;
        bottom: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .play_animate {
        width: 60px;
        height: 60px;
        /*animation: zoom 1s infinite;*/
    }
    .recording {
        width: 60px;
        height: 60px;
    }
    .user_head {
        position: absolute;
        width: 50px;
        height: 50px;
        bottom: 90px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .dialogue_back {
        position: absolute;
        width: 18vmax;
        height: 17.5vmax;
        bottom: 140px;
        left: 50%;
        -webkit-transform: translateX(-50%);
    }
    .dialogue_text {
        position: absolute;
        width: 18vmax;
        height: 17.5vmax;
        padding-left: 10px;
        padding-right: 10px;
        bottom: 140px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        font-size: 15px;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        line-height: 18px;
    }

    .dialogue_data {
        width: 50vmax;
        height: calc(100vmin - 130px);
        position: absolute;
        left: 50%;
        top: 60px;
        -webkit-transform: translateX(-50%);
        overflow-x: hidden;
        overflow-y: scroll;
        font-size: 16px;
        font-weight: bold;
        font-family: "PingFang SC", "Helvetica Neue", "Hiragino Sans GB", "Segoe UI", "Microsoft YaHei", "微软雅黑", sans-serif;
    }

    .dialogue_data .question {
        display: inline-flex;
        margin-top: 15px;
    }
    .dialogue_data .question img {
        width: 35px;
        height: 35px;
        margin-top: 7.5px;
    }
    .dialogue_data .question .content {
        width: calc(50vmax - 105px);
        min-height: 50px;
        background-color: #ffe2d6;
        display: inline-flex;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .dialogue_data .question .content .word_content {
        width: calc(50vmax - 135px);
        padding: 15px 10px;
        word-wrap: break-word;
        overflow: hidden;
    }
    .dialogue_data .question .content .img_play {
        width: 20px;
        height: 20px;
        margin-left: 0;
        margin-right: 10px;
        margin-top: 15px;
    }
    .dialogue_data .right_my_audio {
        width: 40px;
        height: 60px;
    }
    .dialogue_data .left_my_audio {
        width: 40px;
        margin-left: 15px;
        height: 60px;
    }
    .dialogue_data .right_my_audio .img_play, .dialogue_data .left_my_audio .img_play {
        width: 30px;
        height: 30px;
        margin-left: 5px;
        margin-top: 10px;
    }
    .dialogue_data .right_my_audio .my_text, .dialogue_data .left_my_audio .my_text {
        width: 40px;
        height: 40px;
        text-align: center;
        color: white;
        font-size: 10px;
    }

    .dialogue_data .answer {
        display: inline-flex;
        margin-top: 15px;
    }
    .dialogue_data .answer .content {
        width: calc(50vmax - 105px);
        min-height: 50px;
        background-color: #95cdf7;
        display: inline-flex;
        margin-left: 55px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .dialogue_data .answer .content .word_content {
        width: calc(50vmax - 135px);
        padding: 15px 10px;
        word-wrap: break-word;
        overflow: hidden;
    }
    .dialogue_data .answer .content .img_play {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        margin-top: 15px;
    }
    .dialogue_data .answer img {
        width: 35px;
        height: 35px;
        margin-right: 20px;
        margin-top: 7.5px;
    }

    .bottom_space {
        height: 20px;
    }
    .sanjiao_left {
        width: 0;
        height: 0;
        overflow: hidden;
        border-width: 10px;
        margin-top: 15px;
        border-color: transparent transparent transparent #95cdf7;
        border-style: dashed dashed dashed solid;
    }

    .sanjiao_right {
        width: 0;
        height: 0;
        overflow: hidden;
        border-width: 10px;
        margin-top: 15px;
        border-color: transparent #ffe2d6 transparent transparent;
        border-style: dashed solid dashed dashed;
    }

    .first_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(85, 85, 85, 0.96);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .first_content {
        position:relative;
    }

    .first_transition .first_content img {
        position: absolute;
        width: 79px;
        top: -50px;
        right: 20px;
    }

    .first_transition .first_content .content {
        background-color: #fef67e;
        width: calc(100vmin - 40px);
        padding: 20px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        border: 3px solid rgba(0, 0, 0, 1);
    }

    .first_transition .first_content .content .text {
        font-size: 16px;
        color: #101010;
    }

    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }

    .audio_record_anim {
        width: 60px; /*宽高尺寸任意增减*/
        height: 60px;
        background: url(../../assets/record_audio_anim.png) no-repeat;
        background-size: 1000% 100%;
        -webkit-animation: line-slow 0.8s steps(9) infinite;
        animation: line-slow 0.8s steps(9) infinite;
    }

    @keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }

    @-webkit-keyframes line-slow {
        0% {
            background-position: 0% 0%;
        }
        100% {
            background-position: 100% 0%;
        }
    }
    .transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.85);
        z-index: 1002;
    }
    .transition .content {
        position: relative;
        z-index: 1001;
        width: 100%;
        height: 100vmin;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .transition .content2 {
        text-align: center;
    }

    .transition .content3 {
        text-align: center;
    }
    .transition .content .div_icon {
        margin-bottom: 10px;
        width: 100%;
        height: 150px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .transition .content .div_icon .icon {
        width: 136px;
        height: 150px;
    }
    .transition .content .text {
        width: 100%;
    }
    .transition .content .text span {
        display: block;
        text-align: center;
    }
    .transition .content .text .success_tip {
        font-size: 20px;
    }
    .transition .content .star {
        height: 35px;
    }
    .transition .content .star .star_item {
        width: 35px;
        height: 35px;
        display: inline-block;
        position: relative;
    }
    .transition .content .star .star_item img {
        width: 35px;
        height: 35px;
        display: none;
        position: absolute;
        left:50%;
        top: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }
    .transition .content .text span {
        width: 100%;
        color: white;
        font-size: 12px;
    }
    .transition_next {
        margin-top: 30px;
        display: inline-block;
        background-color: #07A745;
        width: 120px;
        height: 40px;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        vertical-align: middle;
        animation: zoom 1s infinite;
        text-align: center;
    }
    .transition_next span {
        display: inline-block;
        font-size: 16px;
        color: white;
        line-height: 39px;
        vertical-align: middle;
    }
    .transition_next img {
        display: inline-block;
        width: 15px;
        vertical-align: middle;
    }
    .transition_comeback {
        margin-top: 30px;
        margin-right: 25px;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        font-size: 0;
    }
    .transition_comeback img {
        display: inline-block;
        width: 40px;
        height: 40px;
    }
    .back_nav2 {
        position: absolute;
        z-index: 1003;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav2 img {
        width: 30px;
        height: 30px;
    }
    .scene_des {
        position: absolute;
        bottom: 20px;
        left: 50%;
        -webkit-transform: translateX(-50%);
        text-align: center;
        font-size: 15px;
        color: white;
        display: inline-block;
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 15px;
        padding-right: 15px;
        background-color: rgba(0,0,0,0.4);
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }

    /*确认按钮样式*/
    .course_main .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .course_main .exit_content {
        position:relative;
    }
    .course_main .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .course_main .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .course_main .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .course_main .exit_content .game_action .game_quit img, .course_main .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .course_main .exit_content .game_action .game_quit span, .course_main .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }

</style>
